export const imagesCarrouselOne = () => {
  return [
    {
      src: '/img/carrouselone/wallpaper-01.jpg',
      alt: 'star wars wallpaper 01',
      title: 'Wallpaper',
      quote: {
        text: 'The Force will be with you. Always',
        author: 'Obi-Wan Kenobi',
      },
    },
    {
      src: '/img/carrouselone/wallpaper-02.jpg',
      alt: 'star wars wallpaper 02',
      title: 'Wallpaper',
      quote: {
        text: 'Do. Or do not. There is no try',
        author: 'Yoda',
      },
    },
    {
      src: '/img/carrouselone/wallpaper-03.jpg',
      alt: 'star wars wallpaper 03',
      title: 'Wallpaper',
      quote: {
        text: 'I will never turn to the dark side. You have failed, your highness. I am a Jedi, like my father before me',
        author: 'Luke Skywalker',
      },
    },
    {
      src: '/img/carrouselone/wallpaper-04.jpg',
      alt: 'star wars wallpaper 04',
      title: 'Wallpaper',
      quote: {
        text: 'Just for once, let me look on you with my own eyes.',
        author: 'Anakin Skywalker',
      },
    },
    {
      src: '/img/carrouselone/wallpaper-05.jpg',
      alt: 'star wars wallpaper 05',
      title: 'Wallpaper',
      quote: {
        text: 'We must keep our faith in the Republic. The day we stop believing democracy can work is the day we lose it',
        author: 'Queen Jamillia',
      },
    },
    {
      src: '/img/carrouselone/wallpaper-06.jpg',
      alt: 'star wars wallpaper 06',
      title: 'Wallpaper',
      quote: {
        text: 'No, i am your father',
        author: 'Darth Vader',
      },
    },
  ];
};

export const imagesCarrouselTwo = () => {
  return [
    {
      src: '/img/movies/movie-the-phantom-menace.jpg',
      alt: 'star wars movie wallpaper',
      title: 'the phantom menace',
      description:
        'Two Jedi escape a hostile blockade to find allies and come across a young boy who may bring balance to the Force, but the long dormant Sith resurface to claim their original glory',
      release: '1999',
    },
    {
      src: '/img/movies/movie-attack-of-the-clones.jpg',
      alt: 'star wars movie wallpaper',
      title: 'attack of the clones',
      description:
        'Ten years after initially meeting, Anakin Skywalker shares a forbidden romance with Padmé Amidala, while Obi-Wan Kenobi investigates an assassination attempt on the senator and discovers a secret clone army crafted for the Jedi',
      release: '2002',
    },
    {
      src: '/img/movies/movie-revenge-of-the-sith.jpg',
      alt: 'star wars movie wallpaper',
      title: 'revenge of the sith',
      description:
        'Three years into the Clone Wars, the Jedi rescue Palpatine from Count Dooku. As Obi-Wan pursues a new threat, Anakin acts as a double agent between the Jedi Council and Palpatine and is lured into a sinister plan to rule the galaxy',
      release: '2005',
    },
    {
      src: '/img/movies/movie-a-new-hope.jpg',
      alt: 'star wars movie wallpaper',
      title: 'a new hope',
      description:
        "Luke Skywalker joins forces with a Jedi Knight, a cocky pilot, a Wookiee and two droids to save the galaxy from the Empire's world-destroying battle station, while also attempting to rescue Princess Leia from the mysterious Darth Vader",
      release: '1977',
    },
    {
      src: '/img/movies/movie-the-empire-strikes-back.jpg',
      alt: 'star wars movie wallpaper',
      title: 'the empire strikes back',
      description:
        'After the Rebels are brutally overpowered by the Empire on the ice planet Hoth, Luke Skywalker begins Jedi training with Yoda, while his friends are pursued across the galaxy by Darth Vader and bounty hunter Boba Fett',
      release: '1980',
    },
    {
      src: '/img/movies/movie-return-of-the-jedi.jpg',
      alt: 'star wars movie wallpaper',
      title: 'return of the jedi',
      description:
        "After a daring mission to rescue Han Solo from Jabba the Hutt, the Rebels dispatch to Endor to destroy the second Death Star. Meanwhile, Luke struggles to help Darth Vader back from the dark side without falling into the Emperor's trap",
      release: '1983',
    },
    {
      src: '/img/movies/movie-the-force-awakens.jpg',
      alt: 'star wars movie wallpaper',
      title: 'the force awakens',
      description:
        'As a new threat to the galaxy rises, Rey, a desert scavenger, and Finn, an ex-stormtrooper, must join Han Solo and Chewbacca to search for the one hope of restoring peace',
      release: '2015',
    },
    {
      src: '/img/movies/movie-the-last-jedi.jpg',
      alt: 'star wars movie wallpaper',
      title: 'the last jedi',
      description:
        'The Star Wars saga continues as new heroes and galactic legends go on an epic adventure, unlocking mysteries of the Force and shocking revelations of the past',
      release: '2017',
    },
    {
      src: '/img/movies/movie-the-rise-of-skywalker.jpg',
      alt: 'star wars movie wallpaper',
      title: 'the rise of skywalker',
      description:
        'In the riveting conclusion of the landmark Skywalker saga, new legends will be born-and the final battle for freedom is yet to come',
      release: '2019',
    },
  ];
};

export const charactersGallery = () => {
  return [
    {
      src: '/img/characters/Anakin-skywalker.png',
      alt: 'character',
      title: 'anakin skywalker',
    },
    {
      src: '/img/characters/Obi-Wan-Kenobi.jpg',
      alt: 'character',
      title: 'obi-wan kenobi',
    },
    {
      src: '/img/characters/yoda.png',
      alt: 'character',
      title: 'yoda',
    },
  ];
};

export const vehiclesGallery = () => {
  return [
    {
      src: '/img/vehicles/imperial.png',
      alt: 'vehicle',
      title: 'imperial',
    },
    {
      src: '/img/vehicles/star-death.png',
      alt: 'vehicle',
      title: 'death star',
    },
    {
      src: '/img/vehicles/x-wing.jpg',
      alt: 'vehicle',
      title: 'x-wing',
    },
  ];
};
